export const IDENTITY_AUTHORITY = process.env.NEXT_PUBLIC_AUTHORITY;
export const IDENTITY_CLIENT_ID = process.env.NEXT_PUBLIC_IDENTITY_CLIENT_ID;
export const IDENTITY_SCOPE = process.env.NEXT_PUBLIC_IDENTITY_SCOPE;
export const IDENTITY_REDIRECT_URI = process.env.NEXT_PUBLIC_REDIRECT_URI;
export const IDENTITY_LOGOUT_REDIRECT_URI =
  process.env.NEXT_PUBLIC_LOGOUT_REDIRECT_URI;
export const IDENTITY_SILENT_REDIRECT_URI =
  process.env.NEXT_PUBLIC_SILENT_REDIRECT_URI;
export const IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME = 60 * 1; // 1 minuto antes de expirar
export const IDENTITY_NECESSARY_ROLES = [
  'Notifier User - PS',
  'Notifier User Pharmacy Clinic - PS',
  'Patient Safety',
  'Observer User - PS',
  'Investigator User - PS',
  'Reports - PS',
  'Account Manager - PS',
  'Network Manager - PS',
  'Leadership User - PS',
  'Responsible for the Action Plan User - PS',
  'Investigation Team User - PS',
  'Alerts - PS',
];

export const LOGGED_IN_USER_LS_KEY = `oidc.user:${process.env.NEXT_PUBLIC_AUTHORITY}:${process.env.NEXT_PUBLIC_IDENTITY_CLIENT_ID}`;
export const REDIRECT_URL_LS_KEY = `redirect_url_sign_in.oidc`;
export const REDIRECT_URL_LS_KEY_VITE = `redirect_url_sign_in.vt.oidc`;

export const MODAL_TIMEOUT_ID = 'modal-timeout-id';
